import { AddHost } from '@/features/store-management/premium-stores/form/AddHostManagement';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/host-management/$clubid/add-host/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AddHost />;
}
